export default __webpack_public_path__ + "static/media/baseline-battery_charging_60-24px.c85e70c3.svg";